import React, { useEffect, useState } from "react";
import {
  Button,
  OverlayTrigger,
  Pagination,
  Table,
  Tooltip,
} from "react-bootstrap";
import Lottie from "lottie-react";
const BannerNoticeTable = (props) => {
  const [getBannerNoticeData, setGetBannerNoticeData] = useState([]);
  const {
    getBannerData,
    LoadingSpinner,
    loading,
    handleNavigateToEditBannerNotice,
    handleDelete,
    currentPage,
    totalPage,
    setCurrentPage,
    safeParseJSON,
  } = props;
  useEffect(() => {
    const addData = getBannerData.map((item) => ({
      ...item,
      selected: false,
    }));
    setGetBannerNoticeData(addData);
  }, [getBannerData]);
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        key={number}
        onClick={() => setCurrentPage(number)}
        active={number === currentPage}
      >
        {number}
      </Pagination.Item>
    );
  }

  const edit = <Tooltip id="edit">Edit</Tooltip>;
  const Delete = <Tooltip id="Delete">Delete</Tooltip>;
  return (
    <div>
      <Table responsive>
        <thead>
          <tr>
            {/* <th>ID</th> */}
            <th>image</th>
            <th>title</th>
            <th>start time</th>
            <th>end time</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7">
                <LoadingSpinner />
              </td>
            </tr>
          ) : getBannerNoticeData && getBannerNoticeData.length === 0 ? (
            <tr>
              <td colSpan="7">
                <center>No record found</center>
              </td>
            </tr>
          ) : (
            getBannerNoticeData &&
            getBannerNoticeData.map((item) => (
              <tr key={item.id}>
                <td>
                  <Lottie
                    animationData={safeParseJSON(item.icon_path)}
                    loop={true}
                    autoplay={true}
                    style={{ height: "55px", width: "70px" }}
                  />
                </td>

                <td>{item.title}</td>
                <td>{item.start_time}</td>
                <td>{item.end_time}</td>
                <td>
                  <OverlayTrigger placement="top" overlay={Delete}>
                    <Button
                      className="btn-simple btn btn-xs btn-danger"
                      simple
                      bsStyle="success"
                      bsSize="xs"
                      style={{ border: "none" }}
                      onClick={() => handleDelete(item.id)}
                    >
                      <i class="fa fa-times" style={{ fontSize: "16px" }} />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={edit}>
                    <Button
                      simple
                      bsStyle="success"
                      bsSize="xs"
                      style={{ border: "none" }}
                      onClick={() => handleNavigateToEditBannerNotice(item.id)}
                    >
                      <i
                        class="fa fa-edit"
                        style={{ fontSize: "16px", color: "#FEA405" }}
                      />
                    </Button>
                  </OverlayTrigger>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Pagination bsSize="medium">{items}</Pagination>
      </div>
    </div>
  );
};
export default BannerNoticeTable;
